const APPOINTMENT_STATUS_SCHEDULED = "Scheduled";
const APPOINTMENT_STATUS_COMPLETED = "Completed";
const APPOINTMENT_STATUS_CHECKED_IN = "Checked In";
const APPOINTMENT_STATUS_PENDING = "Pending";
const APPOINTMENT_STATUS_CANCELLED = "Canceled";
const APPOINTMENT_STATUS_IN_PROGRESS = "In Progress";

const APPOINTMENT_STATUSES = {
  scheduled: APPOINTMENT_STATUS_SCHEDULED,
  test_completed: APPOINTMENT_STATUS_COMPLETED,
  checked_in: APPOINTMENT_STATUS_CHECKED_IN,
  completed: APPOINTMENT_STATUS_COMPLETED,
  vax_complete: APPOINTMENT_STATUS_COMPLETED,
  end_vax: APPOINTMENT_STATUS_COMPLETED,
  pending: APPOINTMENT_STATUS_PENDING,
  cancelled: APPOINTMENT_STATUS_CANCELLED,
  test_in_progress: APPOINTMENT_STATUS_IN_PROGRESS,
  vial_scanned: APPOINTMENT_STATUS_IN_PROGRESS,
  pre_consultation_in_progress: APPOINTMENT_STATUS_IN_PROGRESS,
  scan_vial_vax: APPOINTMENT_STATUS_IN_PROGRESS,
  verify_insurance: APPOINTMENT_STATUS_IN_PROGRESS,
  start_vax: APPOINTMENT_STATUS_IN_PROGRESS
};

export {
  APPOINTMENT_STATUSES,
  APPOINTMENT_STATUS_SCHEDULED,
  APPOINTMENT_STATUS_COMPLETED,
  APPOINTMENT_STATUS_CHECKED_IN,
  APPOINTMENT_STATUS_PENDING,
  APPOINTMENT_STATUS_CANCELLED,
  APPOINTMENT_STATUS_IN_PROGRESS
};
